var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 13,
    fill: "#3423A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 21C27.5229 21 24.4595 22.7736 22.6659 25.4712C22.2837 26.0461 21.5078 26.2023 20.9329 25.8201C20.358 25.4378 20.2018 24.6619 20.5841 24.087C22.8214 20.7221 26.6509 18.5 31 18.5C37.9035 18.5 43.5 24.0964 43.5 31C43.5 37.9035 37.9035 43.5 31 43.5C24.0964 43.5 18.5 37.9035 18.5 31C18.5 30.3096 19.0597 29.75 19.75 29.75H33.5C34.1904 29.75 34.75 30.3096 34.75 31C34.75 31.6904 34.1904 32.25 33.5 32.25H21.0774C21.6925 37.1829 25.9005 41 31 41C36.5229 41 41 36.5229 41 31C41 25.4771 36.5229 21 31 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3839 30.1161C34.872 30.6043 34.872 31.3958 34.3839 31.8839L30.6339 35.6339C30.1457 36.122 29.3542 36.122 28.8661 35.6339C28.378 35.1458 28.378 34.3542 28.8661 33.8661L31.7322 31L28.8661 28.1339C28.378 27.6457 28.378 26.8543 28.8661 26.3661C29.3542 25.878 30.1457 25.878 30.6339 26.3661L34.3839 30.1161Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.5be06685c863c425bbf79ffe5f00db35.svg";
export { ForwardRef as ReactComponent };